
const Spinner = require('./libraries/spinner/index.js')
const chalk = require('chalk')
const path = require('path')
const fs = require('fs')
const homedir = require('os').homedir()

const configFileName = '.ops_cli_config'
const config = require('./libraries/settings.js').file(configFileName)

const clientRoot = config.get('ops_client_path')
const webhookUrl = config.get('slack_webhook_url') || {}

const ROOT_TO_WEBPACK_PATH = '/src/main/webapp'

module.exports = {

	configFileName,

	globals: [
		"jest@21.2.1",
		"jest-cli@21.2.1",
		"webpack@3.10.0",
		"webpack-dev-server@2.7.1"
	],

	spinner: new Spinner({
		color: "cyan",
		spinner: {
			interval: 100,
			frames: [
				"\t-    ",
				"\t  -  ",
				"\t    -",
				"\t  -  "
			]
		}
	}),

	inquirer: require('./libraries/inquirer/lib/inquirer.js'),
	config,
	// TO DO - this link should be part of the config, not made available to everyone, even though it's a cinch to change
	slack: require('./libraries/slack.js')(webhookUrl.qa),

	primary: chalk.hex('#dada0e'),
	// accent: chalk.hex('#b6d5d6'),
	accent: chalk.cyan,
	// danger: chalk.hex('#e85348'),
	danger: chalk.red,
	faded: chalk.gray,

	warn: text => {
		console.log(chalk.red(text))
	},

	newline: () => { 
		console.log('') 
	},

	report: message => { 
		console.log("\t" + message) 
	},
	reportSuccess: message => { 
		console.log("\t✨ " + message + "\n") 
	},

	begin: command => {
		console.log(chalk.cyan(`ops ${command} --\n`))
		return new Promise(resolve => resolve())
	},

	finish: () => {
		console.log('')
		process.exit()
	},

	error: (command, message) => {
		console.log(chalk.red(`ops ${command} error --\n`))
		if (Array.isArray(message)) {
			message.forEach(line => {
				console.log(`\t${line}`)
			})
			console.log(``)
		} else {
			console.log(`\t${message}\n`)
		}
		process.exit(1)
	},

	warn: (message) => {
		console.log(chalk.yellow(`ops warn -- ${message}\n`))
	},

	ROOT_TO_WEBPACK_PATH,
	BASE_URL: 'http://sbxops.sbx.avtr.net',
	CLI_ROOT: __dirname,
	APP_ROOT: clientRoot,
	npmPkg: JSON.parse(fs.readFileSync(
		clientRoot +'/package.json' , 'utf8'
	)),
	ROOT_MODULE: 'root',

	// TEMPLATES_ROOT: path.join(__dirname, 'templates'),
	// STORAGE_DIR_PATH: path.join(homedir, "./ops_cli_storage/"),
	// STORAGE_PATH: path.join(homedir, "./ops_cli_storage/storage.json")
}



// WEBPACK FOOTER //
// ./src/common.js